(function() {

  // Run early
  var path = window.location.pathname;

  if (path.includes('/a/members')) {

    var customer = window.ShopifyCustomer || {};
    var tags = (customer.tags || []).map(t => t.toLowerCase().trim());

    var hasTraining = tags.includes('training');

    if (!customer.logged_in || !hasTraining) {
      window.location.replace('/');
    }

  }

})();

  // ---------- PART 2: MENU CLASS ADD ----------
(function () {

  function applyClass(root = document) {
    root.querySelectorAll(
      'a[title="Stratford Learning Hub"]'
    ).forEach(link => {
      link.classList.add('members-area');
    });
  }

  // Run initially
  applyClass();

  // Run on DOM ready
  document.addEventListener('DOMContentLoaded', applyClass);

  // 🔥 Observe ONLY added nodes (optimized)
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          applyClass(node);
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();

(function () {

  function applyMobileClass() {
    document.querySelectorAll(
      '#mobile-menu a[title="Stratford Learning Hub"]'
    ).forEach(link => {
      link.classList.add('members-area');
    });
  }

  // 🔥 run every time drawer opens
  document.addEventListener('click', function (e) {

    // hamburger / toggle click
    if (
      e.target.closest('[aria-controls="mobile-menu"]') ||
      e.target.closest('.mobile-toggle')
    ) {
      setTimeout(applyMobileClass, 200); // wait for Shopify re-render
    }

  });

})();

// Mobile Javascript

